import Gallery from "../webPage/Gallery";

export default function handleGalleries(){
    let $galleries = $(".js-gallery");

    if ($galleries.length > 0) {
        $galleries.each(function (index, el) {
            new Gallery($(el), {
                itemClass: "gallery__image",
                navigateClass: "js-navigate",
                itemsClass: "js-items",
                itemActiveModifier: "active",
                animationDuration: 700,
                applyMinHeight: false,
                keyboardEvents: false,
            });
        });
    }
}
